import {Component} from '@wonderlandengine/api';
import {setComponentsActive} from './utils/activate-children.js';

/**
 * Deactivate the host object and all descendants once at scene start.
 */
export class DeactivateOnStart extends Component {
    static TypeName = 'deactivate-on-start';

    start() {
        setComponentsActive(this.object, false);
    }
}
